// extracted by mini-css-extract-plugin
export default {"root":"SwitchButton_root__8jr2E","label":"SwitchButton_label__b5PsT"};